export enum PointType {
  None = "None",
  FlyBuys = "FlyBuys",
  AirPoints = "AirPoints",
}
